var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.632 43.9071C39.3594 44.6345 40.3142 45 41.2691 45C42.224 45 43.1789 44.6345 43.9062 43.9071C45.3646 42.4487 45.3646 40.0913 43.9062 38.6328L27.7733 22.4997L43.9062 6.36809C45.3646 4.91338 45.3646 2.55227 43.9062 1.09383C42.4478 -0.36461 40.0905 -0.36461 38.632 1.09383L22.4992 17.2254L6.36796 1.09383C4.90955 -0.36461 2.55222 -0.36461 1.09381 1.09383C-0.364603 2.55227 -0.364603 4.90965 1.09381 6.36809L17.2248 22.4994L1.09381 38.6291C-0.364603 40.0876 -0.364603 42.4449 1.09381 43.9034C1.82115 44.6307 2.77602 44.9963 3.73088 44.9963C4.68575 44.9963 5.64062 44.6307 6.36796 43.9034L22.4989 27.7737L38.632 43.9071Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e9d29ac9b22e82a3d5add008ba946acb.svg";
export { ForwardRef as ReactComponent };